export default "__VITE_ASSET__DnO96GP5__"